"use client";

import React, { memo, type ReactNode } from "react";

// Toggle bar + collapsible overview wrapper used by macro / fed-rates /
// trump category dashboards. Same visual chrome on all three so this
// is a pure presentation component — owns no state. The parent
// (MarketsPageContent) keeps the expanded boolean per category and
// persists to localStorage on toggle, so the overview toggle stays in
// sync between this main render path and the Elections render path
// that reuses the same flags.
export const DashboardOverviewToggle = memo(function DashboardOverviewToggle({
  label,
  expanded,
  onToggle,
  children,
}: {
  /** Localised "Market Overview" label shown next to the switch. */
  label: string;
  expanded: boolean;
  onToggle: () => void;
  /** The dashboard component to reveal — passed as children so the
   *  caller controls which `<XDashboard />` lazy-loaded chunk renders. */
  children: ReactNode;
}) {
  return (
    <>
      <div className="flex items-center justify-end mb-3">
        <button
          onClick={onToggle}
          className="flex items-center gap-2"
          title={label}
        >
          <span className="text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wide whitespace-nowrap">{label}</span>
          <div className={`relative w-9 h-5 rounded-[5px] transition-colors duration-200 ${expanded ? "bg-gray-900 dark:bg-white" : "bg-gray-300 dark:bg-gray-600"}`}>
            <div className={`absolute top-[2px] w-4 h-4 rounded-[5px] bg-white dark:bg-gray-900 transition-transform duration-200 ${expanded ? "translate-x-[18px]" : "translate-x-[2px]"}`} />
          </div>
        </button>
      </div>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${expanded ? "max-h-[3000px] opacity-100" : "max-h-0 opacity-0"}`}>
        {children}
      </div>
    </>
  );
});
